import { useAuth } from '@/lib/auth'
import { captureException } from '@/lib/errors'
import { performMutations, useMutation } from '@/lib/mutations'
import { useStore } from '@/lib/pocketbase'

interface RejectTimeEntryData {
    entryId: string
    orgId: string
    reason: string
}

export function useRejectTimeEntry() {
    const { user } = useAuth()
    const [timeEntriesCollection] = useStore('time_entries')

    const mutation = useMutation({
        mutationFn: async (data: RejectTimeEntryData) => {
            if (!user?.id) {
                throw new Error('User not found')
            }

            const now = new Date().toISOString()

            return await performMutations(function* () {
                yield timeEntriesCollection.update(data.entryId, draft => {
                    draft.status = 'rejected'
                    draft.approved_by = user.id
                    draft.approved_at = now
                    draft.rejection_reason = data.reason
                })
            })
        },
        onError: error => {
            captureException('Reject time entry failed', error)
        },
    })

    return {
        mutate: mutation.mutate,
        mutateAsync: mutation.mutateAsync,
        isPending: mutation.isPending,
    }
}
